<h1>テストページ SSN分</h1>
<div class="testTitle">
  <p>ログイン状態変更</p>
  <button id="login" class="testButton" (click)="login()">ログイン</button>
  <button id="logout" class="testButton" (click)="logout()">ログアウト</button>
</div>
<div class="testTitle">
  <p>注意喚起エリア</p>
  <button id="alert-error-on" class="testButton" (click)="errorOn()">エラー表示</button>
  <button id="alert-error-off" class="testButton" (click)="errorOff()">エラー削除</button>
  <button id="alert-warning-on" class="testButton" (click)="warningOn()">ワーニング追加</button>
  <button id="alert-infomation-on" class="testButton" (click)="infomationOn()">インフォメーション追加</button>
  <button id="alert-clear" class="testButton" (click)="alertClear()">storeクリア</button>
</div>
<div class="testTitle">
  <p>注意喚起エリア（メッセージID指定）</p>
  ID: <input type="text" id="message-id-input" name="message-id-input" class="testInput" #messageId /><br />
  <button id="alert-warning-id-on" class="testButton" (click)="warningIdOn(messageId.value)">ワーニング追加</button>
  <button id="alert-warning-id-delete" class="testButton" (click)="warningIdDelete(messageId.value)">
    ワーニング削除
  </button>
  <button id="alert-infomation-id-on" class="testButton" (click)="infomationIdOn(messageId.value)">
    インフォメーション追加
  </button>
  <button id="alert-infomation-id-delete" class="testButton" (click)="infomationIdDelete(messageId.value)">
    インフォメーション削除
  </button>
</div>
<div class="testTitle">
  <p>静的文言</p>
  <div class="testBlock">
    ・通常
    <div [innerHTML]="'heading.pleaseSelectDepartureDate' | staticMsg"></div>
  </div>
  <div class="testBlock">
    ・引数 translate
    <div [innerHTML]="'label.male.title' | staticMsg : { '0': 'test taro' }"></div>
  </div>
  <div class="testBlock">
    ・引数 popupのみ
    <div [innerHTML]="'label.privacyPolicy' | staticMsg : {} : 'white'"></div>
  </div>
</div>
<div class="testTitle">
  <p>動的文言表示</p>
  <p>表示する：緊急案内エリア、ガイダンスエリア、注意喚起エリア、同意文言エリアに項目が表示されます</p>
  <button id="dynamicOn" class="testButton" (click)="dynamicOn()">表示する</button>
  <button id="dynamicOff" class="testButton" (click)="dynamicOff()">表示しない</button>
</div>
<div class="testTitle">
  <p>ボックスラジオボタン</p>
  <div class="testBlock">
    ・パターン1
    <asw-radiobutton-box id="test-radiobutton-box1" legend="test1" [text]="boxtext"></asw-radiobutton-box>
  </div>
  <div class="testBlock">
    ・パターン2
    <asw-radiobutton-box
      id="test-radiobutton-box2"
      legend="test2"
      [text]="boxtext"
      [(selectedItem)]="boxSelect"
      [(value)]="boxSelectValue"
      [errorMessage]="error1"
    ></asw-radiobutton-box>
    <div>選択文字:{{ boxSelect }}</div>
    <div>選択番号:{{ boxSelectValue }}</div>
  </div>
</div>
<div class="testTitle">
  <p>トグル</p>
  <div class="testBlock">
    ・パターン1
    <asw-toggle text="toggle" [(checked)]="toggleCheck" (changeEvent)="toggleChange($event)"></asw-toggle>
    toggle:{{ toggleCheck }}
  </div>
</div>
<div class="testTitle">
  <p>タブ</p>
  <div class="testBlock">
    ・パターン1
    <asw-tabs id="testTabs" (selectEvent)="tabClick($event)">
      <asw-tabs-item title="tab1">
        <asw-tab-test text="タブテスト画面 1"></asw-tab-test>
      </asw-tabs-item>
      <asw-tabs-item title="tab2">
        <asw-tab-test text="タブテスト画面 2"></asw-tab-test>
      </asw-tabs-item>
    </asw-tabs>
  </div>
</div>
<div class="testTitle">
  <p>年月日プルダウン</p>
  <div class="testBlock">
    ・パターン1
    <asw-select-date-ymd></asw-select-date-ymd>
  </div>
  <div class="testBlock">
    ・パターン2
    <asw-select-date-ymd
      order="YMD"
      [dateFrom]="dateFromYmd"
      [dateTo]="dateToYmd"
      [(selectedDate)]="testDate"
      (changeEvent)="changeDate($event)"
      [initialDate]="{ year: 2023, month: 12, day: 24 }"
      [errorMessage]="error2"
    ></asw-select-date-ymd>
  </div>
  <div class="testBlock">
    ・パターン3 (ReactiveForm)
    <form [formGroup]="ymdForm" (ngSubmit)="ymdSubmit()">
      <asw-select-date-ymd order="YMD" formControlName="ymd" [errorMessage]="error3"></asw-select-date-ymd>
      <br />
      <asw-button (click$)="ymdSubmit()">Submit</asw-button>
      <br />
      <br />
      <asw-button (click$)="add10days()">10日を追加</asw-button>
      <br /><br />
    </form>
  </div>
</div>
<div class="testTitle">
  <p>同意文言エリア</p>
  <div class="testBlock">
    ・パターン1
    <asw-agreement-area [agreementAreaParts]="agreementAreaParts" [(agreeStatus)]="agreeStatus"></asw-agreement-area>
    <span>agree = {{ agreeStatus }}</span>
  </div>
  <div class="testBlock">
    ・パターン2 文言なし時非表示
    <asw-agreement-area [agreementAreaParts]="agreementAreaParts2" [(agreeStatus)]="agreeStatus2"></asw-agreement-area>
    <span>agree = {{ agreeStatus2 }}</span>
  </div>
</div>
<div class="testTitle">
  <p>空港選択</p>
  <div class="testBlock">
    ・パターン1
    <asw-airport
      [oldAswTerm]="isOldAswTerm"
      [(selectedAirport)]="selectedAirport"
      [airportListParts]="airportListParts"
      id="AirportTest"
      [airportFormControl]="airportFormControl"
      (changeEvent)="changeAirportEvent($event)"
      [errorMessage]="error1"
    ></asw-airport>
    <div>
      <button id="toggleOldAswTerm" class="testButton" (click)="toggleOldAswTerm()">
        旧国内ASW取扱検索条件フラグ切り替え
      </button>
      {{ isOldAswTerm }}
    </div>
  </div>
  <div class="testBlock">
    ・パターン2 (※バリデーションの都合で一度helloWorldページに戻る必要あり)
    <asw-airport-round>
      <asw-airport
        origin
        label="origin"
        [airportListParts]="airportListPartsFrom"
        [(selectedAirport)]="selectedAirportFrom"
        [airportFormControl]="f['airportDep']"
        (airportListToParent)="receiveDataFromChild($event)"
        id="roundAirFrom"
      ></asw-airport>
      <asw-airport
        #airportTo
        destination
        [airportListParts]="airportListPartsTo"
        [(selectedAirport)]="selectedAirportTo"
        [airportFormControl]="f['airportArr']"
        (airportListToParent)="receiveDataFromChild($event)"
        id="roundAirTo"
      ></asw-airport>
    </asw-airport-round>
  </div>
  <div class="testBlock">
    ・パターン3 乗継地 (※バリデーションの都合で一度helloWorldページに戻る必要あり)
    <div class="p-input-list-area02__block-item-box">
      <div class="c-form-element-input c-form-element-input--has-function">
        <asw-airport
          #transitDepartComponent
          label="Transit Airport"
          [airportListParts]="airportListPartsTransit"
          [(selectedAirport)]="selectedAirportTransit"
          [airportFormControl]="f['airportTra']"
          (airportListToParent)="receiveDataFromChild($event)"
          id="roundtrip-airport-from-connection"
        ></asw-airport>
      </div>
    </div>
  </div>
  <div class="testBlock">
    ・パターン4 区間n (※バリデーションの都合で一度helloWorldページに戻る必要あり)
    <ng-container *ngFor="let bound of this.boundList; index as boundIndex">
      <div class="p-input-list-area01">
        <div class="p-input-list-area01__item">
          <div class="p-input-list-area01__block">
            <div class="p-input-list-area01__block-item">
              <div class="p-input-list-area01__heading">
                <h3
                  class="p-input-list-area01__heading-title"
                  [innerHTML]="'label.number.section.n' | staticMsg : { '0': boundIndex + 1 }"
                ></h3>
              </div>
              <asw-airport-round [switchBtnHidden]="true">
                <asw-airport
                  #originAirportComponent
                  id="airport-from-{{ boundIndex }}"
                  origin
                  label="Departure"
                  [airportListParts]="bound.airportListPartsFrom ?? airportListPartsFrom"
                  [airportFormControl]="bound.originLocationFormControl"
                ></asw-airport>
                <asw-airport
                  #destinationAirportComponent
                  id="airport-to-{{ boundIndex }}"
                  destination
                  label="Arrival"
                  [airportListParts]="bound.airportListPartsTo ?? airportListPartsTo"
                  [airportFormControl]="bound.destinationLocationFormControl"
                ></asw-airport>
              </asw-airport-round>
            </div>
          </div>
        </div>

        <div class="p-input-list-area01__item">
          <div class="p-input-list-area01__block p-input-list-area01__block--half">
            <div class="p-input-list-area01__block-item">
              <div class="p-input-list-area01__block-item-box">
                <asw-date-selector
                  #departureDateComponent
                  [dateSelectorParts]="bound.dateSelectorParts ?? dateSelectorParts"
                  [dateForm]="bound.departureDateFormControl"
                >
                </asw-date-selector>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="testBlock">
    ・パターン5 (※フォームラベル国際化対応)
    <asw-airport-round>
      <asw-airport
        origin
        label="origin"
        [airportListParts]="airportListPartsFromExcludeInputLabel"
        [(selectedAirport)]="selectedAirportFrom"
        [airportFormControl]="f['airportDep']"
        (airportListToParent)="receiveDataFromChild($event)"
        id="round-airport-from-input-label-test"
      ></asw-airport>
      <asw-airport
        #airportTo
        destination
        [airportListParts]="airportListPartsToExcludeInputLabel"
        [(selectedAirport)]="selectedAirportTo"
        [airportFormControl]="f['airportArr']"
        (airportListToParent)="receiveDataFromChild($event)"
        id="round-airport-to-input-label-test"
      ></asw-airport>
    </asw-airport-round>
  </div>
</div>
<div class="testTitle">
  <p>出発日選択</p>
  <div class="testBlock">
    ・パターン1：組み込み元から基準日(baseDate)の指定あり
    <asw-date-selector
      id="dataselector1"
      [dateForm]="dateSelectorFormControl"
      [dateSelectorParts]="dateSelectorPartsOneway"
      [(selectedDate)]="selectedDateOneway"
    ></asw-date-selector>
  </div>
  <div class="testBlock">
    ・パターン2
    <asw-date-selector
      #dateSelector
      id="dataselector1"
      [dateForm]="dateSelectorFormGroup"
      [dateSelectorParts]="dateSelectorParts"
      [(selectedDate)]="selectedDate"
      [(selectedReturnDate)]="selectedReturnDate"
      id="roundDateTo"
    ></asw-date-selector>
  </div>
  <div class="testBlock">
    ・パターン3：組み込み元から基準日(baseDate)の指定なし
    <asw-date-selector
      id="dataselector3"
      [dateForm]="dateSelectorFormControlWithoutBaseDate"
      [dateSelectorParts]="dateSelectorPartsOnewayWithoutBaseDate"
      [(selectedDate)]="selectedDateOnewayWithoutBaseDate"
    ></asw-date-selector>
  </div>
</div>
<div class="testTitle">
  モーダル
  <asw-select label="モーダルタイプ" [formControl]="selectModalType">
    <option value="option1">タイプ1</option>
    <option value="option2">タイプ2</option>
    <option value="option3">タイプ3</option>
    <option value="option4">タイプ4</option>
    <option value="option5">タイプ5</option>
    <option value="option6">タイプ6</option>
    <option value="option7">タイプ7</option>
    <option value="option8">タイプ8</option>
    <option value="option9">タイプ9</option>
    <option value="option10">タイプ10</option>
  </asw-select>
  <asw-select label="モーダルサイズ" [formControl]="selectModalWidth">
    <option value="option1">TAB345</option>
    <option value="option2">TAB384</option>
    <option value="option3">TAB540</option>
    <option value="option4">TAB768</option>
    <option value="option5">PC500</option>
    <option value="option6">PC600</option>
    <option value="option7">PC768</option>
    <option value="option8">PC1000</option>
    <option value="option9">指定なし</option>
    <option value="option10">未設定</option>
  </asw-select>
  <asw-checkbox label="背景クリック時に閉じる" (change$)="modalCloseChecked($event)"></asw-checkbox>
  <button class="testButton" id="ssnTestButtonId" (click)="testModal()">モーダル表示</button>
  <button class="testButton" id="id-modal-on" (click)="testIdModal()">ID付きモーダル表示</button>
</div>
